type EntryCallback<T> = (entry: T) => void;

export const GlobalIntersectionObserver = {
  map: new Map<Element, EntryCallback<IntersectionObserverEntry>>(),
  $$observer: null as IntersectionObserver | null,

  observe(node: Element, entryCallBack: EntryCallback<IntersectionObserverEntry>): void {
    this.map.set(node, entryCallBack);

    if (this.$$observer) {
      this.$$observer.disconnect();
    }

    this.$$observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const fnCallBack = this.map.get(entry.target);
        if (fnCallBack) {
          fnCallBack(entry);
        }
      });
    });

    this.map.forEach((_, key) => this.$$observer?.observe(key));
  },

  unobserve(node: Element): void {
    this.map.delete(node);
    this.$$observer?.unobserve(node);
  },

  disconnect(): void {
    this.map.clear();
    if (this.$$observer) {
      this.$$observer.disconnect();
    }
  },
};

export const GlobalResizeObserver = {
  map: new Map<Element, EntryCallback<ResizeObserverEntry>>(),
  $$observer: null as ResizeObserver | null,

  observe(node: Element, entryCallBack: EntryCallback<ResizeObserverEntry>): void {
    this.map.set(node, entryCallBack);

    if (this.$$observer) {
      this.$$observer.disconnect();
    }

    this.$$observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const fnCallBack = this.map.get(entry.target);
        if (fnCallBack) {
          fnCallBack(entry);
        }
      });
    });

    this.map.forEach((_, key) => this.$$observer?.observe(key));
  },

  unobserve(node: Element): void {
    this.map.delete(node);
    this.$$observer?.unobserve(node);
  },

  disconnect(): void {
    this.map.clear();
    if (this.$$observer) {
      this.$$observer.disconnect();
    }
  },
};
